import { Context } from "../context";
import { GameStateManager } from "../managers/GameStateManager";
import { PoserClock } from "../util/clock";
import { Frames } from "../util/frame";
import { Ball } from "./ball";
import { Bat } from "./bat";
import { LightRig } from "./lights/lights";
import { Skybox } from "./lights/skybox";
import { Stadium } from "./stadium/stadium";
import { StrikeZone } from "./strikezone";

export class World {
  ball: Ball;
  bat: Bat;
  strikezone: StrikeZone;

  stadium: Stadium;
  lights: LightRig;

  private contextRef: Context;
  private prevFrameNum = -1;

  constructor(context: Context) {
    // TODO: don't pass context on construction, but on update
    this.ball = new Ball(context);
    this.bat = new Bat(context);
    this.strikezone = new StrikeZone();

    this.stadium = new Stadium();

    this.lights = new LightRig(context);

    // TODO: bring actor management into world

    // Add ball
    context.scene.add(this.ball.object);
    context.scene.add(this.ball.trail.object);
    context.scene.add(this.ball.pad.object);

    // Add bat
    context.scene.add(this.bat.object);

    // Add strikezone
    context.scene.add(this.strikezone.object);

    // Add stadium
    context.scene.add(this.stadium.object);

    this.contextRef = context;
  }

  async init() {
    await this.stadium.init(this.contextRef);

    document.addEventListener("dragover", this.dragOverCb);
    document.addEventListener("dragenter", this.dragEnterCb);
    document.addEventListener("dragleave", this.dragLeaveCb);
    document.addEventListener("drop", this.dropCb);
  }

  teardown() {
    document.removeEventListener("dragover", this.dragOverCb);
    document.removeEventListener("dragenter", this.dragEnterCb);
    document.removeEventListener("dragleave", this.dragLeaveCb);
    document.removeEventListener("drop", this.dropCb);
  }

  update(clock: PoserClock, gameState: GameStateManager, frames?: Frames) {
    if (!clock.atBufferLimit() && frames && frames.current && frames.next) {
      const frameNum = frames.current.num;

      if (frameNum != this.prevFrameNum) {
        // Strike zone
        this.strikezone.update(gameState, frames.current);
      }

      // Ball
      this.ball.update(frames, clock.realMs);

      // Bat
      this.bat.update(frames, clock.realMs);

      this.prevFrameNum = frameNum;
    }

    this.stadium.update(clock);

    // TODO: put some things on a slower update loop
    // skybox
    this.lights.update(clock);
  }

  // drag-drop stadium handlers
  private dragOverCb = (event: DragEvent) => {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = "copy";
    }
  };

  private dragEnterCb = () => {
    document.body.style.opacity = "0.5";
  };

  private dragLeaveCb = () => {
    document.body.style.opacity = "1";
  };

  private dropCb = (event: DragEvent) => {
    event.preventDefault();

    const reader = new FileReader();
    reader.addEventListener("load", (loadEvent) => {
      if (loadEvent.target?.result) {
        const dataUrl = loadEvent.target.result as string;
        const mimeType = dataUrl.split(",")[0].split(":")[1].split(";")[0];

        if (mimeType == "image/jpeg") {
          this.lights.skybox.makeSky(loadEvent.target.result as string, "");
        } else {
          const path = loadEvent.target.result as string;
          this.stadium.init(this.contextRef, path);
        }
      }
    });

    if (event.dataTransfer) {
      reader.readAsDataURL(event.dataTransfer.files[0]);
    }
    document.body.style.opacity = "1";
  };
}
